const searchModalOpen = document.querySelectorAll('.primaryNav-search-button--trigger');

Array.from(searchModalOpen).forEach((button) => {
  // eslint-disable-next-line no-param-reassign
  button.onclick = function onclick(e) {
    e.preventDefault();

    document.documentElement.classList.add('search-modal-active');
    setTimeout(() => {
      document.getElementById('input-focus').focus();
    }, 100);
  };
});
